module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/centros/centros.component.css
// module id = ./src/app/centros/centros.component.css
// module chunks = main